module.exports = __webpack_public_path__ + "img/palladium hotels-logo.8f1067eb.png";